module.exports = __webpack_public_path__ + "static/img/noMap.c10741b7.png";